import { render } from "./hat_contant.vue?vue&type=template&id=d6ae4bfa&scoped=true"
const script = {}

import "./hat_contant.vue?vue&type=style&index=0&id=d6ae4bfa&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ae4bfa"]])

export default __exports__